import store from "@/store";
import {AuthActionTypes} from "@/store/auth";

export default function useAuthentication() {
    const onResetCredentials = async () => {await store.dispatch(AuthActionTypes.REMOVE_CREDENTIALS)};
    return {
        onResetCredentials
    }
}